export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID, // Your React app ID
    // authority:"https://login.microsoftonline.com/a1173525-a51d-4390-81ad-45f38067ebc7",
    authority:
      "https://login.microsoftonline.com/0b886b93-9ced-4970-9ac4-dd7797798817",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (message.includes("popup")) {
          console.log("MSAL Popup Log:", message);
        }
      },
      logLevel: "Info",
    },
    allowRedirectInIframe: false, // ✅ ADD THIS - Prevents iframe issues
  },
};

// Request token for YOUR backend API (not Microsoft Graph)
export const loginRequest = {
  // scopes: ["api://a5451d0f-f4c0-45c0-bf35-254c237be2ca/access_as_user"], // Make sure this is correct
  scopes: ["api://ebcaf93b-866f-450d-86a0-2bf334053481/access_as_user"],
};

// Optional: If you still need user profile
export const profileRequest = {
  scopes: ["openid", "profile", "email"],
};
